export const passwordRequirements = [
  '8-24 characters',
  'includes letters',
  'includes numbers',
  'no spaces',
  'include at least one special character !@#$%^&*()+',
];
